import { createBrowserHistory as createHistory } from 'history';
import constants from 'utils/constants';

class Initialiser {
    constructor() {
        this.history = createHistory();
        this.initialState = {
            upload: {
                modalOpen: false,
            },
            calendly: {
                modalOpen: false,
                modalTitle: '',
                modalContent: '',
                modalAction: '',
            },
            fetching: [],
            user: {},
            dashboard: {
                summary: {},
                actions: [],
                matching: {},
            },
            works: { total: 0, offset: 0, limit: 0, works: [] },
            work: { metadata: {} },
            hover: {
                ipis: [
                    {
                        ipi: constants.HoverIPIs.NONE,
                        view: constants.ShareView.NONE,
                    },
                ],
                entityType: constants.EntityType.NONE,
                shareType: constants.ShareType.NONE,
            },
            toaster: [],
            notifications: { loading: true, items: [], status: 'OK' },
            performance: {},
            messages: { inbox: [], selectedMessage: {}, searchResult: [] },
            royalties: [],
            file_status: [],
            matching_dashboard: {
                selected_report_type: {},
            },
            api_tokens: {
                searchResults: [],
                searchPerformed: false,
                isSearching: false,
                tokensByUser: {},
                endpoints: [],
                userLoading: {},
                error: null,
                createdToken: null,
            },
        };
    }
}

export default new Initialiser();
